import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import rootReducer from './modules/reducer'

import {autoRehydrate} from 'redux-persist'

export const history = createHistory()

const enhancers = []
const middleware = [
    thunk,
    routerMiddleware(history)
]

if (process.env.NODE_ENV === 'development') {
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

    if (typeof devToolsExtension === 'function') {
        enhancers.push(devToolsExtension())
    }
}

const composedEnhancers = compose(
    autoRehydrate(),
    applyMiddleware(...middleware),
    ...enhancers
)

const store = createStore(
    rootReducer,
    composedEnhancers
)

export default store


// WEBPACK FOOTER //
// ./src/store.js